"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _a;
var React = require("react");
var ui_1 = require("@vidazoo/ui");
var utils_1 = require("@vidazoo/ui/lib/components/utils");
var ReportFieldValueCell_1 = require("./ReportFieldValueCell");
var ReportGroupValueCell_1 = require("./ReportGroupValueCell");
var DensityLineHeight = (_a = {},
    _a[ui_1.Density.Large] = 53,
    _a[ui_1.Density.Medium] = 47,
    _a[ui_1.Density.Small] = 41,
    _a);
var ReportingList = /** @class */ (function (_super) {
    tslib_1.__extends(ReportingList, _super);
    function ReportingList(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onQuickConstraint = function (item) {
            var quickConstraint = _this.props.quickConstraint;
            quickConstraint(item);
        };
        _this.onQuickFilter = function (item) {
            var quickFilter = _this.props.quickFilter;
            quickFilter(item);
        };
        _this.onDocumentKeyDown = _this.onDocumentKeyDown.bind(_this);
        _this.onDocumentKeyUp = _this.onDocumentKeyUp.bind(_this);
        _this.groupsToLinksTimer = null;
        _this.willUnmount = false;
        _this.state = { transformGroupsToLinks: false };
        return _this;
    }
    ReportingList.prototype.getMouseEventMap = function () {
        return {
            keydown: this.onDocumentKeyDown,
            keyup: this.onDocumentKeyUp
        };
    };
    ReportingList.prototype.componentDidMount = function () {
        utils_1.addEventsToDocument(this.getMouseEventMap());
    };
    ReportingList.prototype.componentWillUnmount = function () {
        this.willUnmount = true;
        window.clearTimeout(this.groupsToLinksTimer);
        utils_1.removeEventsFromDocument(this.getMouseEventMap());
    };
    ReportingList.prototype.onDocumentKeyDown = function (e) {
        var _this = this;
        var _a = this.props, transformGroupsToLinksByKeyCode = _a.transformGroupsToLinksByKeyCode, transformGroupsToLinksTimeout = _a.transformGroupsToLinksTimeout;
        if (e.which === transformGroupsToLinksByKeyCode) {
            this.groupsToLinksTimer = setTimeout(function () {
                if (!_this.willUnmount) {
                    _this.setState({
                        transformGroupsToLinks: true
                    });
                }
            }, transformGroupsToLinksTimeout);
        }
    };
    ReportingList.prototype.onDocumentKeyUp = function () {
        window.clearTimeout(this.groupsToLinksTimer);
        if (this.state.transformGroupsToLinks) {
            this.setState({
                transformGroupsToLinks: false
            });
        }
    };
    ReportingList.prototype.render = function () {
        var _this = this;
        var _a = this.props, groups = _a.groups, fields = _a.fields, results = _a.results, filteredTotal = _a.filteredTotal, loadMore = _a.loadMore, onSearch = _a.onSearch, searchQueries = _a.searchQueries, onSort = _a.onSort, sortBy = _a.sortBy, sortDirection = _a.sortDirection, density = _a.density, page = _a.page, pageSize = _a.pageSize, quickConstraint = _a.quickConstraint, quickFilter = _a.quickFilter;
        var list = results;
        if (page && pageSize) {
            list = results.slice(0, page * pageSize);
        }
        return (React.createElement(ui_1.Surface, { level: 1 },
            React.createElement(ui_1.NativeScrollable, { scrollSize: 14, suppressY: true, stickyOverflowScrollX: true, bold: true },
                React.createElement(ui_1.Table, { density: density, fill: true, enableStickyHeader: true, stickyHeaderOffsetTop: 68, loadMoreItems: loadMore },
                    React.createElement(ui_1.TableBody, { itemHeight: DensityLineHeight[density] }, list.map(function (item) { return (React.createElement("tr", { key: item.id },
                        item.groups.map(function (group, idx) { return (React.createElement(ui_1.TableCell, { key: group.name, highlight: sortBy === group.name, edge: idx === item.groups.length - 1 },
                            React.createElement(ReportGroupValueCell_1.default, { group: group, onQuickFilter: _this.onQuickFilter, enableQuickFilter: group.hasFilterType && !!quickFilter }))); }),
                        item.fields.map(function (field) { return field.isRequested && (React.createElement(ui_1.TableCell, { key: field.name, highlight: sortBy === field.name },
                            React.createElement(ReportFieldValueCell_1.default, { field: field, onQuickConstraint: _this.onQuickConstraint, enableQuickConstraint: !!quickConstraint }))); }))); })),
                    React.createElement("thead", null,
                        React.createElement("tr", null,
                            groups.map(function (group, idx) { return (React.createElement(ui_1.TableHeaderColumn, { deepPurple: true, key: group.name, label: group.name, sortable: true, sortBy: group.name, sortActive: sortBy === group.name, searchable: true, onSearch: onSearch, edge: idx === groups.length - 1, searchKey: group.name, searchQuery: searchQueries[group.name], sortDirection: sortDirection, onSort: onSort })); }),
                            fields.map(function (field) { return field.isRequested ?
                                React.createElement(ui_1.TableHeaderColumn, { deepPurple: true, key: field.name, label: field.name, sortable: true, sortBy: field.name, sortActive: sortBy === field.name, sortDirection: sortDirection, onSort: onSort }) : null; })),
                        React.createElement("tr", null,
                            groups.map(function (group, idx) { return React.createElement(ui_1.TableHeaderSummaryColumn, { key: group.name, highlight: sortBy === group.name, edge: idx === groups.length - 1 }); }),
                            fields.map(function (field, idx) {
                                if (!field.isRequested) {
                                    return null;
                                }
                                var filtered = filteredTotal[idx] || { name: "", value: "" };
                                var value = filtered.displayValue;
                                return (React.createElement(ui_1.TableHeaderSummaryColumn, { key: field.name || idx, highlight: sortBy === field.name, title: filtered.typeSup, value: value }));
                            })))))));
    };
    ReportingList.defaultProps = {
        groups: [],
        fields: [],
        transformGroupsToLinksByKeyCode: 18,
        transformGroupsToLinksTimeout: 250
    };
    return ReportingList;
}(React.Component));
exports.default = ReportingList;
